var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"welcome-box"},[_vm._t("header",[_c('svg-vue',{staticClass:"logo",attrs:{"icon":"logo"}})]),_vm._v(" "),_c('div',{staticClass:"content"},[_vm._t("default")],2),_vm._v(" "),_vm._t("footer")],2)}
var staticRenderFns = []

export { render, staticRenderFns }